import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';

import type { ThemeTabType } from '../../../../entities/post/models';

import type { Depth } from '@/entities/insight';
import { Button } from '@/shared/components/shadcn/button';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/shadcn/tabs';

interface ThemeTableHeaderProps {
  level: 'theme' | 'brand' | 'product';
  selectedTab: ThemeTabType;
  onTabChange: (tab: ThemeTabType) => void;
  depths: Depth[];
  onBack: () => void;
}

export function ThemeTableHeader({
  level,
  selectedTab,
  onTabChange,
  depths,
  onBack,
}: ThemeTableHeaderProps) {
  if (level === 'theme') {
    // Theme level: Show tabs
    return (
      <Tabs value={selectedTab} onValueChange={(value) => onTabChange(value as ThemeTabType)}>
        <TabsList>
          <TabsTrigger value="all">All themes</TabsTrigger>
          <TabsTrigger value="positive">Positive</TabsTrigger>
          <TabsTrigger value="negative">Negative</TabsTrigger>
        </TabsList>
      </Tabs>
    );
  }

  // Brand/Product level: Show breadcrumb navigation
  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="icon" onClick={onBack} className="h-10 w-10">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      {depths.map((depth, index) => (
        <React.Fragment key={`${depth.dimension}-${depth.value}`}>
          <span className="text-card-foreground text-xl font-semibold">{depth.value}</span>
          {index !== depths.length - 1 && (
            <ChevronRight className="text-muted-foreground h-4 w-4" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
